document.addEventListener('DOMContentLoaded', function () {
  // Open first collapsible by default
  const firstCollapsible = document.querySelector('.accordion details');
  if (firstCollapsible) {
    firstCollapsible.setAttribute('open', '');
  }

  // Scroll-triggered animation on accordion content
  const observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('accordion-visible');
        observer.unobserve(entry.target); // animate once only
      }
    });
  }, { threshold: 0.2 });

  document.querySelectorAll('.accordion details').forEach(function (details) {
    observer.observe(details);
  });
});



// Hover to open standard dropdown menus
document.querySelectorAll('header-menu').forEach(function (headerMenu) {
  const details = headerMenu.querySelector('details:not(.mega-menu)');
  if (!details) return;

  let closeTimer = null;

  headerMenu.addEventListener('mouseenter', function () {
    if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
    if (!details.hasAttribute('open')) {
      details.setAttribute('open', '');
    }
  });

  headerMenu.addEventListener('mouseleave', function () {
    closeTimer = setTimeout(function () {
      details.removeAttribute('open');
    }, 100);
  });
});


